import React from 'react';
import type { ReactNode } from 'react';
import classNames from 'classnames';

import { Pin, RhythmScore } from './components';
import type { PinProps, RhythmScoreProps } from './components';

import './YatBadge.scss';

export interface YatBadgeProps {
    children: ReactNode;
    motionEntrance?: boolean;
}

function PinWrapper(props: PinProps) {
    return (
        <div className="PinWrapper">
            <Pin {...props} />
        </div>
    );
}

function RhythmScoreWrapper(props: RhythmScoreProps) {
    return (
        <div className="RhythmScoreWrapper">
            <RhythmScore {...props} />
        </div>
    );
}

// TODO: We probably want to author a `<YatBadgeCombo />`
// component instead of this sub-component approach.
// That way we can take a unified props API.
export function YatBadge({ children, motionEntrance = false }: YatBadgeProps) {
    const yatBadgeClassNames = classNames('YatBadge', {
        'YatBadge--motionEntrance': motionEntrance,
    });
    return <div className={yatBadgeClassNames}>{children}</div>;
}

YatBadge.Pin = PinWrapper;
YatBadge.RhythmScore = RhythmScoreWrapper;
